export const getInputFields = (findDoc) =>
	[...findDoc].map((el) => ({
		id: el.getAttribute('id'),
		fieldname: el?.getAttribute('name') ? el.getAttribute('name') : '',
		placeholder: el?.getAttribute('placeholder')
			? el.getAttribute('placeholder')
			: 'placeholder',
		type: el.getAttribute('type') || 'text',
		value: el.getAttribute('value') || '',
		min: el.getAttribute('min') || '',
		max: el.getAttribute('max') || '',
		required: el.getAttribute('required') === 'true',
		isChecked: el.getAttribute('checked') === 'true',
		isrecipient: el.dataset.type
	}));

export const getDropdownFields = (findSelectDropDown, selectDetails) => {
	for (const el of findSelectDropDown) {
		const optionsList = el.querySelectorAll('option');

		const options = [];
		if (optionsList?.length) {
			for (const item of optionsList) {
				options.push(item.innerHTML);
			}
		}

		selectDetails.push({
			required: el.getAttribute('required'),
			options,
			id: el.getAttribute('id')
		});
	}
};
